import { Overlay } from '@angular/cdk/overlay';
import { Directive, ElementRef, Input, Optional, SimpleChanges } from '@angular/core';

import { EditorJSONState, EditorMode } from '@recruitee/prosemirror';

import { ProsemirrorConfig, ProsemirrorService } from '../components/wysiwg/prosemirror.service';
import { ProsemirrorDefaultConfig } from '../configs/default-config';
import { ProsemirrorViewboxConfig } from '../configs/viewbox-config';
import { MentionsStream$, StateUpdated$ } from '../consts';
import { OVERLAY_PROVIDERS } from '../providers';

@Directive({
  selector: '[prosemirrorRender]',
  providers: [
    ProsemirrorService,
    StateUpdated$,
    ProsemirrorDefaultConfig,
    ProsemirrorViewboxConfig,
    OVERLAY_PROVIDERS,
  ],
})
export class RenderDirective {
  @Input('prosemirrorRender') public state?: object | null;
  @Input('prosemirrorRenderConfig') public config: ProsemirrorConfig;

  constructor(
    private elementRef: ElementRef,
    private prosemirrorService: ProsemirrorService,
    @Optional()
    private mentionsProvider$: MentionsStream$,
  ) {}

  public ngOnInit() {
    this.prosemirrorService.createEditor(this.elementRef.nativeElement, this.config, {
      mode: EditorMode.View,
      initialState: <EditorJSONState>this.state,
    });
  }

  public ngOnChanges(changes: SimpleChanges) {
    const { state } = changes;
    if (state && !state.firstChange) {
      this.prosemirrorService.updateState(<EditorJSONState>this.state);
    }
  }
}
